import styled from 'styled-components';

import colors from 'apps/promo/theme/colors';
import media from 'apps/promo/theme/media';

const shouldForwardContainerProp = (prop) => !['insideModalComponent'].includes(prop);
const shouldForwardMainTextProp = (prop) => !['hasBorder', 'breakWord'].includes(prop);

export const Container = styled.div.withConfig({ shouldForwardProp: shouldForwardContainerProp })`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    padding: ${(props) => (props.insideModalComponent ? '0' : '72px 24px 92px 24px')};
`;

export const CenterContainer = styled.div`
    width: 100%;
    max-width: 504px;
`;

export const HeaderText = styled.div`
    font-size: 24px;
    line-height: 36px;
    margin-top: 24px;
    color: ${colors.baseColor};

    span,
    .color-GT {
        color: ${colors.purple};
    }

    ${media.desktop1920} {
        font-size: 32px;
        line-height: 48px;
    }
`;
export const SecondaryText = styled.div`
    font-size: 17px;
    line-height: 24px;
    margin-top: 16px;
    color: ${colors.mediumGray};

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
    }
`;

export const MainText = styled.span.withConfig({ shouldForwardProp: shouldForwardMainTextProp })`
    display: inline-block;
    font-size: 17px;
    line-height: 24px;
    margin-top: 24px;
    border-bottom: ${(props) => (props.hasBorder ? `1px solid ${colors.greyRgba28}` : null)};
    padding-bottom: ${(props) => (props.hasBorder ? '32px' : null)};
    word-break: ${(props) => (props.breakWord ? 'break-word' : null)};

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
        padding-bottom: ${(props) => (props.hasBorder ? '48px' : null)};
    }
`;

export const RowButtonContainer = styled.div`
    margin-top: 16px;

    ${media.desktop1920} {
        margin-top: 28px;
    }
`;
